import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { BettingOddsNavItem } from 'common/react/components/competition-nav/nav-items';
import { FixturesList } from './fixtures-list/FixturesList';
import { EmptyState } from 'common/react/components/EmptyState';
import { useGetAllContentQuery } from 'common/store/modules/api/content-api';

export const NoFilterFixtures = (data) => {
    const gatherRound = data?.gatherRound ? true : false;

    const competitionId = data.competitionId;
    const competitionPid = data.competitionPid;
    const compSeason = {
        providerId: data.seasonPid,
        id: Number(data.seasonId)
    };
    const roundNumber = Number(data.noFilterRound);

    // contents param should be in format ?contents=PROMO:{reference},PROMO:{reference}
    const broadcasterPromoIds = data?.broadcasterPromos
        ?.split(',')
        .map((id) => `PROMO:${id}`);

    const { data: broadcasterPromoData = [] } = useGetAllContentQuery(
        {
            params: {
                contents: broadcasterPromoIds?.join(',')
            }
        },
        { skip: !broadcasterPromoIds }
    );

    const broadcasterPromo = useMemo(() => {
        const found = broadcasterPromoData.find((promo) => {
            let compReference = promo.references?.find(
                (ref) => ref.type === 'AFL_COMPETITION'
            );
            return compReference.id === competitionId;
        });

        return found;
    }, [broadcasterPromoData, competitionId]);

    return (
        <>
            <div className="wrapper widget">
                {!compSeason?.providerId ||
                !compSeason?.id ||
                isNaN(roundNumber) ? (
                    <EmptyState cssClass="competition-nav__empty-state" />
                ) : (
                    <>
                        <div className="fixtures__header-wrapper">
                            <h2 className="fixtures__header-wrapper__title widget-header__title">
                                {data.title}
                            </h2>
                            <BettingOddsNavItem
                                cssClass="fixtures__header-wrapper__betting-toggle"
                                gatherRound={true}
                                compSeasonPid={compSeason.providerId}
                                roundNumber={roundNumber}
                            />
                        </div>
                        <FixturesList
                            competitionId={competitionId}
                            competitionPid={competitionPid}
                            compSeason={compSeason}
                            roundNumber={roundNumber}
                            broadcasterPromo={broadcasterPromo}
                            gatherRound={gatherRound}
                        />
                    </>
                )}
            </div>
        </>
    );
};

NoFilterFixtures.propTypes = {
    data: PropTypes.object
};
